import React from "react";
import PropTypes from "prop-types";
import { useRecoilValue } from "recoil";
import { getUserRole } from "recoil/Auth";
import ButtonComponent from "components/ButtonComponent";

function TrackStudentActions({ data, props }) {
  const userRole = useRecoilValue(getUserRole);
  const awardCredits = () => {
    props.awardCredits(data);
  };

  return (
    <div className="d-flex gap-3 table-actions">
      <div className="position-relative">
        {userRole !== "STUDENT" && (
          <ButtonComponent
            text={"award_credits"}
            variant={"orange-1"}
            onClick={awardCredits}
          />
        )}
      </div>
    </div>
  );
}
TrackStudentActions.propTypes = {
  data: PropTypes.object.isRequired,
  props: PropTypes.object.isRequired,
};
export default TrackStudentActions;
